export default __webpack_public_path__ + "static/media/carbon_enterprise.3da9f9d2.svg";